import React from 'react';
import SelectButton from '../SearchForm/children/SelectButton';
import styles from './RadioSelect.module.scss';
export const RadioSelect = ({ onChange = () => { }, values, value = null, }) => (<div className={styles.select}>
    <ul className={styles.list}>
      {values === null || values === void 0 ? void 0 : values.map(({ name, value: code }) => (<li className={styles.item} key={code}>
          <SelectButton key={name} value={name} onClick={() => onChange(code)} checked={value === code}/>
        </li>))}
    </ul>
  </div>);
export default RadioSelect;
